
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GebindeDto } from "../../dtos/gebindeDto";
import httpClient from "../../store/httpClient";
import GebindeComponent from "./GebindeComponent.vue";

@Component({
	components: {
		GebindeComponent,
	},
})
export default class DefineGebindeComponent extends Vue {
	@Prop()
	private ticketId!: number;
	private allGebinde: GebindeDto[] = [];
	private loading: boolean = false;

	private mounted() {
		this.loadGebinde();
	}

	private async loadGebinde() {
		try {
			this.loading = true;
			const response = await httpClient().get(`Ticket/GetGebinde?ticketId=${this.ticketId}`);
			this.allGebinde = response.data;
		} finally {
			this.loading = false;
		}
	}

	private async saveGebinde(gebinde: GebindeDto) {
		try {
			this.loading = true;
			const response = await httpClient().post(
				`Ticket/UpdateGebinde?ticketId=${this.ticketId}`,
				gebinde
			);
			gebinde.id = response.data;
		} finally {
			this.loading = false;
		}
	}

	private async addGebinde() {
		const gebinde: GebindeDto = {
			id: 0,
			name: "",
			weight: 0,
			length: 0,
			width: 0,
			height: 0,
			timeEffort: 0,
			numberOfEuropalettes: 0,
			numberOfEuropalettesFrames: 0,
			numberOfEuropalettesLid: 0,
		};
		await this.saveGebinde(gebinde);
		console.log(gebinde);
		console.log(this.allGebinde);
		this.allGebinde.push(gebinde);
	}

	private async deleteGebinde(gebinde: GebindeDto) {
		try {
			this.loading = true;
			const response = await httpClient().post(
				`Ticket/deleteGebinde?gebindeId=${gebinde.id}`
			);
			this.allGebinde.splice(this.allGebinde.indexOf(gebinde), 1);
		} finally {
			this.loading = false;
		}
	}

	private async createDelivery() {
		try {
			this.loading = true;
			await httpClient().post(`Ticket/CreateNacharbeitDelivery?ticketId=${this.ticketId}`);
			this.$emit("createdDelivery");
		} finally {
			this.loading = false;
		}
	}
}
